<div style="padding: 24px">
    <div class="one-row">
        <span class="spacer" data-cy="kugrugr_span_1"></span>
        <kiene-zeitauswahl (change)="zeitintervalChanged($event)"></kiene-zeitauswahl>
        <span class="spacer" data-cy="kugrugr_span_2"></span>
    </div>

    <table class="report-ergebnis-table">
        <thead>
            <tr>
                <th></th>
                <th>Anzahl Unternehmensgruppen</th>
                <th>Umsatz Gesamt</th>
                <th>Wareneinsatz Gesamt</th>
                <th>Rohertrag Gesamt</th>
                <th>Anzahl Abgabebelege/Befunde</th>
            </tr>
        </thead>
        <tbody>
            <tr style="font-size: 1.6em; font-weight: bold; color: green">
                <td style="font-size: 1em; font-weight: bold; color: gray" data-cy="kugrugr_td_1"></td>
                <td data-cy="kugrugr_td_2">{{ anzahlAktuell | number: "1.0-0" }}</td>
                <td data-cy="kugrugr_td_3">{{ gesamtUmsatz | number: "1.2-2" }} &euro;</td>
                <td data-cy="kugrugr_td_4"
                    ><span data-cy="kugrugr_span_3">{{ gesamtWareneinsatz | number: "1.2-2" }} &euro;</span><br />
                    <span style="font-size: 0.8em; color: gray" data-cy="kugrugr_span_4"
                        >&#8793; {{ gesamtWareneinsatzProzent }} &percnt;</span
                    ></td
                >
                <td data-cy="kugrugr_td_5"
                    ><span data-cy="kugrugr_span_5">{{ gesamtRohertrag | number: "1.2-2" }} &euro;</span><br />
                    <span style="font-size: 0.8em; color: gray" data-cy="kugrugr_span_6"
                        >&#8793; {{ gesamtRohertragProzent }} &percnt;</span
                    ></td
                >
                <td data-cy="kugrugr_td_6">{{ abgabebelegeGesamt | number: "1.0-0" }}</td>
            </tr>
            <tr style="font-size: 1em; font-weight: bold; color: gray">
                <td data-cy="kugrugr_td_7"
                    >{{ vorjahreszeitraum?.von | date: "dd.MM.yyyy" }} bis
                    {{ vorjahreszeitraum?.bis | date: "dd.MM.yyyy" }}</td
                >
                <td data-cy="kugrugr_td_8">{{ dataSourceVorjahr?.data?.length | number: "1.0-0" }}</td>
                <td data-cy="kugrugr_td_9">{{ gesamtUmsatzVorjahr | number: "1.2-2" }} &euro;</td>
                <td data-cy="kugrugr_td_10"
                    >{{ gesamtWareneinsatzVorjahr | number: "1.2-2" }} &euro; ({{ gesamtWareneinsatzProzentVorjahr }}
                    &percnt;)
                </td>
                <td data-cy="kugrugr_td_11"
                    >{{ gesamtRohertragVorjahr | number: "1.2-2" }} &euro; ({{ gesamtRohertragProzentVorjahr }}
                    &percnt;)
                </td>
                <td data-cy="kugrugr_td_12">{{ abgabebelegeGesamtVorjahr | number: "1.0-0" }}</td>
            </tr>
        </tbody>
    </table>

    <!--    <div class="one-row" style="min-height: 300px">-->
    <!--        <kiene-report-overview-value-card [label]="'Anzahl Unternehmensgruppen'" [numberValue]="dataSource.data.length"-->
    <!--                                          [numberValueVorjahr]="dataSourceVorjahr.data.length"-->
    <!--                                          [numberFormat]="'1.0-0'"-->
    <!--                                          [prefixIcon]="'tag'"></kiene-report-overview-value-card>-->
    <!--        <kiene-report-overview-value-card [label]="'Umsatz Gesamt'" [numberValue]="gesamtUmsatz"-->
    <!--                                          [numberValueVorjahr]="gesamtUmsatzVorjahr"-->
    <!--                                          [numberFormat]="'1.2-2'" [unit]="'&euro;'"-->
    <!--                                          [secondRow]="'&#8793;100 %'"></kiene-report-overview-value-card>-->
    <!--        <kiene-report-overview-value-card [label]="'Wareneinsatz Gesamt'" [numberValue]="gesamtWareneinsatz"-->
    <!--                                          [numberValueVorjahr]="gesamtWareneinsatzVorjahr"-->
    <!--                                          [numberFormat]="'1.2-2'" [unit]="'&euro;'"-->
    <!--                                          [secondRow]="gesamtWareneinsatzProzent + '%'"-->
    <!--                                          [secondRowVorjahr]="gesamtWareneinsatzProzentVorjahr + '%'">-->
    <!--        </kiene-report-overview-value-card>-->
    <!--        <kiene-report-overview-value-card [label]="'Rohertrag Gesamt'" [numberValue]="gesamtRohertrag"-->
    <!--                                          [numberValueVorjahr]="gesamtRohertragVorjahr"-->
    <!--                                          [numberFormat]="'1.2-2'" [unit]="'&euro;'"-->
    <!--                                          [secondRow]="gesamtRohertragProzent + '%'"-->
    <!--                                          [secondRowVorjahr]="gesamtRohertragProzentVorjahr + '%'">-->
    <!--        </kiene-report-overview-value-card>-->
    <!--        <kiene-report-overview-value-card [label]="'Anzahl Abgabebelege'" [numberValue]="abgabebelegeGesamt"-->
    <!--                                          [numberValueVorjahr]="abgabebelegeGesamtVorjahr"-->
    <!--                                          [numberFormat]="'1.0-0'"-->
    <!--                                          [prefixIcon]="'tag'"></kiene-report-overview-value-card>-->
    <!--    </div>-->

    <div class="one-row">
        <mat-form-field>
            <mat-label>Tierarztgruppe</mat-label>
            <mat-select [formControl]="tierarztgruppeCtrl" multiple (openedChange)="tierarztgruppeOpenChange($event)">
                <mat-option *ngFor="let tg of tierarztgruppen" [value]="tg" data-cy="kugrugr_mat-option_1">{{
                    tg.bezeichnung
                }}</mat-option>
            </mat-select>
        </mat-form-field>
        <span class="spacer" data-cy="kugrugr_span_7"></span>
        <mat-checkbox
            [formControl]="ergaenzerCtrl"
            (change)="loadData()"
            style="margin-right: 24px"
            matTooltip="Artikel mit Warengruppe Ergänzer berücksichtigen"
            data-cy="kugrugr_mat-checkbox_1"
            >mit Ergänzern</mat-checkbox
        >
        <mat-checkbox
            [formControl]="rabattCtrl"
            (change)="loadData()"
            matTooltip="Kundenrabatte und Kundengutschriften abgezogen"
            data-cy="kugrugr_mat-checkbox_2"
            >Bereinigter Umsatz</mat-checkbox
        >
        <mat-form-field class="umsatz-filter">
            <mat-label>Umsatz ggü. Vorjahr</mat-label>
            <mat-select [formControl]="umsatzFilterCtrl">
                <mat-option value="alle">Alle</mat-option>
                <mat-option value="weniger">Weniger Umsatz</mat-option>
                <mat-option value="stark">Mindestens 50 % weniger</mat-option>
                <mat-option value="weg">Nicht mehr da</mat-option>
            </mat-select>
        </mat-form-field>
    </div>

    <mat-card>
        <div class="one-row">
            <span class="spacer" data-cy="kugrugr_span_8"></span>
            <kiene-csv-export [columns]="csvColumns" [data]="dataSource.filteredData" [filename]="csvFilename">
            </kiene-csv-export>
        </div>
        <table mat-table [dataSource]="dataSource" multiTemplateDataRows matSort>
            <!-- Position Column -->
            <ng-container matColumnDef="unternehmensgruppe">
                <th mat-header-cell *matHeaderCellDef mat-sort-header> Unternehmensgruppe </th>
                <td mat-cell *matCellDef="let element" data-cy="kugrugr_td_13">
                    {{ element.unternehmensgruppe }}
                </td>
            </ng-container>
            <ng-container matColumnDef="adresse">
                <th mat-header-cell *matHeaderCellDef mat-sort-header> Adresse </th>
                <td mat-cell *matCellDef="let element" data-cy="kugrugr_td_14">
                    {{ element.adresse }}
                </td>
            </ng-container>
            <ng-container matColumnDef="tierarztgruppe">
                <th mat-header-cell *matHeaderCellDef mat-sort-header> Tierarztgruppe </th>
                <td mat-cell *matCellDef="let element" data-cy="kugrugr_td_15">
                    {{ element.tierarztgruppe }}
                </td>
            </ng-container>

            <!-- Name Column -->
            <ng-container matColumnDef="umsatz_prozent">
                <th mat-header-cell *matHeaderCellDef mat-sort-header class="number-header"> Umsatz von Gesamt (%) </th>
                <td mat-cell *matCellDef="let element" class="number" data-cy="kugrugr_td_16">
                    {{ element.umsatz_prozent | number: "1.0-2" }} %
                </td>
            </ng-container>
            <ng-container matColumnDef="umsatz">
                <th mat-header-cell *matHeaderCellDef mat-sort-header class="number-header"> Umsatz </th>
                <td mat-cell *matCellDef="let element" class="number" data-cy="kugrugr_td_17">
                    {{ element.umsatz | number: "1.2-2" }} &euro;
                </td>
            </ng-container>
            <ng-container matColumnDef="umsatz_delta_prozent">
                <th
                    mat-header-cell
                    *matHeaderCellDef
                    mat-sort-header
                    class="number-header"
                    matTooltip="Veränderung zum Vorjahreszeitraum. −100 % = im aktuellen Zeitraum kein Umsatz mehr. „neu“ = im Vorjahr kein Umsatz."
                >
                    ggü. Vorjahr (%)
                </th>
                <td
                    mat-cell
                    *matCellDef="let element"
                    class="number"
                    [class.delta-down]="element.umsatz_delta_prozent < 0"
                    [class.delta-up]="element.umsatz_delta_prozent > 0"
                >
                    <ng-container *ngIf="element.umsatz_delta_prozent != null; else umsatzNeu">
                        {{ element.umsatz_delta_prozent | number: "1.0-1" }} %
                    </ng-container>
                    <ng-template #umsatzNeu>
                        <span *ngIf="element.umsatz > 0; else keinUmsatzVergleich">neu</span>
                        <ng-template #keinUmsatzVergleich>–</ng-template>
                    </ng-template>
                </td>
            </ng-container>

            <!-- Weight Column -->
            <ng-container matColumnDef="wareneinsatz">
                <th mat-header-cell *matHeaderCellDef mat-sort-header class="number-header"> Wareneinsatz </th>
                <td mat-cell *matCellDef="let element" class="number" data-cy="kugrugr_td_18">
                    {{ element.wareneinsatz | number: "1.2-2" }} &euro;
                </td>
            </ng-container>
            <ng-container matColumnDef="wareneinsatz_prozent">
                <th mat-header-cell *matHeaderCellDef mat-sort-header class="number-header"> Wareneinsatz (%) </th>
                <td mat-cell *matCellDef="let element" class="number" data-cy="kugrugr_td_19">
                    {{ element.wareneinsatz_prozent | number: "1.0-2" }} %
                </td>
            </ng-container>

            <!-- Symbol Column -->
            <ng-container matColumnDef="rohertrag">
                <th mat-header-cell *matHeaderCellDef mat-sort-header class="number-header"> Rohertrag </th>
                <td mat-cell *matCellDef="let element" class="number" data-cy="kugrugr_td_20">
                    {{ element.rohertrag | number: "1.2-2" }} &euro;
                </td>
            </ng-container>
            <ng-container matColumnDef="rohertrag_prozent">
                <th mat-header-cell *matHeaderCellDef mat-sort-header class="number-header"> Rohertrag (%) </th>
                <td mat-cell *matCellDef="let element" class="number" data-cy="kugrugr_td_21">
                    {{ element.rohertrag_prozent | number: "1.0-2" }} %
                </td>
            </ng-container>

            <ng-container matColumnDef="abgabebelege">
                <th mat-header-cell *matHeaderCellDef mat-sort-header class="number-header">
                    Anz. Abgabebelege/Befunde
                </th>
                <td mat-cell *matCellDef="let element" class="number" data-cy="kugrugr_td_22">
                    {{ element.abgabebelege | number: "1.0-0" }}
                </td>
            </ng-container>

            <ng-container matColumnDef="aggregatedDetail">
                <td mat-cell *matCellDef="let element" [attr.colspan]="displayedColumns.length" data-cy="kugrugr_td_23">
                    <div
                        class="aggregated-vetgroup-detail"
                        [@detailExpanded]="element == expandedElement ? 'expanded' : 'collapsed'"
                    >
                        <div *ngIf="isLoading[element.unternehmensgruppe_id]" class="one-row">
                            <span class="spacer" data-cy="kugrugr_span_9"></span>
                            <mat-spinner [diameter]="32"></mat-spinner>
                            <span class="spacer" data-cy="kugrugr_span_10"></span>
                        </div>
                        <div *ngIf="!isLoading[element.unternehmensgruppe_id]" class="one-row">
                            <span class="spacer" data-cy="kugrugr_span_11"></span>
                            <kiene-csv-export
                                [columns]="csvColumnsDetails"
                                [data]="element.details"
                                [filename]="'Unternehmensgruppe_Gesamt_' + element.unternehmensgruppe + '.csv'"
                            ></kiene-csv-export>
                        </div>
                        <table
                            *ngIf="!isLoading[element.unternehmensgruppe_id]"
                            class="details-table"
                            style="table-layout: fixed; padding-bottom: 24px"
                        >
                            <tr *ngFor="let d of element.details">
                                <td style="padding-left: 24px" data-cy="kugrugr_td_24">
                                    {{ d.zeitraum }}
                                </td>
                                <td class="number" data-cy="kugrugr_td_25">
                                    {{ d.umsatz_prozent | number: "1.0-2" }} %
                                </td>
                                <td class="number" data-cy="kugrugr_td_26">
                                    {{ d.umsatz | number: "1.2-2" }} &euro;
                                </td>
                                <td class="number" data-cy="kugrugr_td_27">
                                    {{ d.wareneinsatz | number: "1.2-2" }}
                                    &euro;
                                </td>
                                <td class="number" data-cy="kugrugr_td_28">
                                    {{ d.wareneinsatz_prozent | number: "1.0-2" }}
                                    %
                                </td>
                                <td class="number" data-cy="kugrugr_td_29">
                                    {{ d.rohertrag | number: "1.2-2" }} &euro;
                                </td>
                                <td class="number" data-cy="kugrugr_td_30">
                                    {{ d.rohertrag_prozent | number: "1.0-2" }}
                                    %
                                </td>
                                <td class="number" data-cy="kugrugr_td_31">
                                    {{ d.abgabebelege | number: "1.0-0" }}
                                </td>
                            </tr>
                        </table>
                    </div>
                </td>
            </ng-container>

            <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
            <tr
                mat-row
                *matRowDef="let element; columns: displayedColumns"
                class="vet-group-row"
                [class.vet-group-expanded-row]="expandedElement === element"
                (click)="expandVetGroupRow(element)"
            ></tr>
            <tr mat-row *matRowDef="let row; columns: ['aggregatedDetail']" class="aggregated-row"></tr>
        </table>
    </mat-card>

    <mat-card style="margin-bottom: 24px; margin-top: 24px; height: 300px">
        <mat-form-field style="width: 250px">
            <mat-label>Bitte Diagrammtyp ausw&auml;hlen</mat-label>
            <mat-select [(value)]="chartType">
                <mat-option value="Line" data-cy="kugrugr_mat-option_2">Linie</mat-option>
                <mat-option value="Bar" data-cy="kugrugr_mat-option_3">Balken</mat-option>
            </mat-select>
        </mat-form-field>
        <google-chart
            style="width: 100%"
            [options]="{
                chart: { title: expandedElement ? 'Für Unternehmensgruppe: ' + expandedElement.unternehmensgruppe : '' }
            }"
            [type]="chartType"
            [columns]="chartColumns"
            [data]="chartData"
        >
        </google-chart>
    </mat-card>

    <mat-card style="margin-bottom: 24px; margin-top: 24px; height: 600px">
        <google-chart
            style="width: 100%"
            [height]="600"
            [options]="{ title: 'Umsatz Unternehmensgruppen', pieHole: 0.4 }"
            [type]="chartTypeGesamt"
            [columns]="chartColumnsGesamt"
            [data]="chartDataGesamt"
        >
        </google-chart>
    </mat-card>
</div>
